/**
 * Review/SRS constants — iOS-exact geometry & timing.
 * iOS ref: client-native/src/features/review/components/FlashCard.tsx,
 * SwipeableCard.tsx, SwipeReviewScreen.tsx.
 *
 * iOS uses fractions of the phone screen (0.85*W × 0.55*H). On the PWA we cap
 * with a max so the card stays phone-sized on wide desktop (responsive §5).
 */
export const CARD_BORDER_RADIUS = 32; // CARD_BORDER_RADIUS atom (iOS)
export const CARD_MAX_WIDTH = 420;
export const CARD_MAX_HEIGHT = 560;

/** Card shadow — iOS shadowOffset{0,8} opacity0.18 radius16. */
export const CARD_SHADOW = "0 8px 16px rgba(0,0,0,0.18)";

/** Flip: 400ms cubic-out (Easing.out(Easing.cubic)). */
export const FLIP_MS = 400;
export const FLIP_EASING = "cubic-bezier(0.33, 0, 0.67, 1)";

/** Pane slide between Definition/Context. */
export const PANE_MS = 200;

/** Swipe gesture thresholds (iOS). */
export const DRAG_FEEDBACK_THRESHOLD = 50; // px — stamps + button highlight on
export const SWIPE_COMMIT_FRACTION = 0.55; // of card-area width
export const SWIPE_VELOCITY_THRESHOLD = 900; // px/s
export const FLYOUT_GESTURE_MS = 250;
export const FLYOUT_BUTTON_MS = 300;
export const MAX_ROTATE_DEG = 15; // at full-width drag

/** Highlight hold after a swipe before clearing (iOS keeps it 300ms). */
export const HIGHLIGHT_HOLD_MS = 300;

/** Persisted reversed-mode toggle (iOS MMKV → localStorage on web). */
export const REVERSED_STORAGE_KEY = "isReviewReversed";

/** Daily review badge cap (iOS DAILY_REVIEW_BADGE_DISMISS_THRESHOLD). */
export const DAILY_REVIEW_BADGE_THRESHOLD = 30;
